// Libraries
import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

// Models
import { CanComponentDeactivate } from './can-leave.interface';

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
  /**
   * Check if current route can be deactivated.
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof CanDeactivateGuard
   */
  canDeactivate(
    component: CanComponentDeactivate,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
     return component.canDeactivate ? component.canDeactivate() : true;
  }
}
